export const ErrorMessage = {
  CLIENT: 'Client-side error occurred',
  SERVER:'Server-side error occurred',
  TYPE: 'ERROR'
};